import { Plugin } from '@ckeditor/ckeditor5-core';
import { Widget } from '@ckeditor/ckeditor5-widget';
import { toWidget } from '@ckeditor/ckeditor5-widget';
import InsertSalariesCommand from './salaries-command';
export default class SalariesEditing extends Plugin {
    static get requires() {
        return [Widget];
    }
    init() {
        this._defineSchema();
        this._defineConverters();
        this.editor.commands.add('insertSalaries', new InsertSalariesCommand(this.editor));
    }
    _defineSchema() {
        const schema = this.editor.model.schema;
        schema.register('salaries', {
            isObject: true,
            allowContentOf: '$root',
            allowWhere: '$block',
        });
        schema.register('heading', {
            isObject: true,
            allowContentOf: '$block',
            allowIn: 'salaries',
        });
        schema.register('salaryItem', {
            isLimit: true,
            allowContentOf: '$block',
            allowIn: 'salaries',
        });
        schema.register('salaryTitle', {
            isLimit: true,
            allowContentOf: '$block',
            allowIn: 'salaryItem',
        });
        schema.register('salaryBarEmpty', {
            isLimit: true,
            allowContentOf: '$block',
            allowIn: 'salaryItem',
        });
        schema.register('salaryBar', {
            isLimit: true,
            allowContentOf: '$block',
            allowIn: 'salaryBarEmpty',
        });
        schema.register('salaryAmnt', {
            isLimit: true,
            allowContentOf: '$block',
            allowIn: 'salaryItem',
        });
        schema.register('salaryFooter', {
            isLimit: true,
            allowContentOf: '$block',
            allowIn: 'salaries',
        });
    }
    _defineConverters() {
        const conversion = this.editor.conversion;
        conversion.elementToElement({
            model: 'salaries',
            view: {
                name: 'div',
                classes: 'salaries',
            },
        });
        conversion.elementToElement({
            model: 'heading',
            view: {
                name: 'h4',
                classes: '',
            },
        });
        conversion.for('downcast').elementToElement({
            model: 'salaries',
            view: (model, { writer }) => {
                const element = writer.createContainerElement('div', {
                    class: 'salaries',
                });
                return toWidget(element, writer, { label: 'salaries' });
            },
        });
        conversion.elementToElement({
            model: 'salaryItems',
            view: {
                name: 'div',
                classes: 'salary__items',
            },
        });
        conversion.elementToElement({
            model: 'salaryItem',
            view: {
                name: 'div',
                classes: 'salary__item',
            },
        });
        conversion.elementToElement({
            model: 'salaryTitle',
            view: {
                name: 'div',
                classes: 'salary__item_title',
            },
        });
        conversion.elementToElement({
            model: 'salaryBarEmpty',
            view: {
                name: 'div',
                classes: 'salary__item_bar_empty',
            },
        });
        conversion.for('editingDowncast').elementToElement({
            model: 'salaryBar',
            view: (model, { writer }) => {
                const attrs = {
                    class: 'salary__item_bar',
                };
                let width = model.getAttribute('width');
                if (width) {
                    attrs.style = 'width: ' + width;
                }
                return writer.createContainerElement('div', attrs);
            },
        });
        conversion.elementToElement({
            model: 'salaryBar',
            view: {
                name: 'div',
                classes: 'salary__item_bar',
            },
        });
        conversion.elementToElement({
            model: 'salaryAmnt',
            view: {
                name: 'div',
                classes: 'salary__item_amnt',
            },
        });
        conversion.elementToElement({
            model: 'salaryFooter',
            view: {
                name: 'div',
                classes: 'salary__footer',
            },
        });
    }
}
